export default __webpack_public_path__ + "static/media/moha.b40a5cb8.jpg";